import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import axios from 'axios';
import moment from 'moment';
import { api, versao } from '../../config';
import { getHeaders } from '../../actions/localStorage';
import {
	ENTREGA_AGENDADA,
	SAIU_PARA_ENTREGA,
	PEDIDO_ENTREGUE,
	PEDIDO_NAO_ENTREGUE,
} from '../../constants/entregaStatus';

/** Mesmas cores que `.entregasDashboard-card--*.is-active` em EntregasDashboardCards. */
function deliveryStatusHeadClass(entrega){
	if(!entrega || !entrega.status) return 'entregaDetalhesExpand-deliveryStatus--outro';
	const s = entrega.status;
	if(s === ENTREGA_AGENDADA){
		return entrega.loteAtual
			? 'entregaDetalhesExpand-deliveryStatus--agendada'
			: 'entregaDetalhesExpand-deliveryStatus--semLote';
	}
	if(s === SAIU_PARA_ENTREGA) return 'entregaDetalhesExpand-deliveryStatus--saiu';
	if(s === PEDIDO_ENTREGUE) return 'entregaDetalhesExpand-deliveryStatus--entregue';
	if(s === PEDIDO_NAO_ENTREGUE) return 'entregaDetalhesExpand-deliveryStatus--naoEntregue';
	if(s === 'Cancelado pela loja') return 'entregaDetalhesExpand-deliveryStatus--cancelado';
	return 'entregaDetalhesExpand-deliveryStatus--outro';
}

function fmtData(d){
	if(!d) return '—';
	try {
		return new Date(d).toLocaleString('pt-BR');
	}catch(_e){
		return '—';
	}
}

/** Preserva cliente do pedido vindo da listagem quando o merge com a API devolve só o id do pedido. */
function mergeEntregaCliente(linhaEntrega, fetched){
	if(!fetched) return linhaEntrega;
	const merged = { ...linhaEntrega, ...fetched };
	const pedLinha = linhaEntrega.pedido && typeof linhaEntrega.pedido === 'object' ? linhaEntrega.pedido : null;
	const pedFetch = fetched.pedido && typeof fetched.pedido === 'object' ? fetched.pedido : null;
	if(pedFetch && pedFetch.cliente && (pedFetch.cliente.nome || (pedFetch.cliente.telefones && pedFetch.cliente.telefones[0]))){
		merged.pedido = pedFetch;
	}else if(pedLinha && pedLinha.cliente){
		merged.pedido = { ...(pedFetch || {}), ...pedLinha };
	}
	return merged;
}

function urlMapsProva(geo){
	if(!geo || typeof geo.lat !== 'number' || typeof geo.lng !== 'number') return null;
	return `https://www.google.com/maps/search/?api=1&query=${geo.lat},${geo.lng}`;
}

function urlConfirmacaoAbs(token){
	if(!token || typeof window === 'undefined') return '';
	return `${window.location.origin}${window.location.pathname}#/delivery-confirmation/${token}`;
}

export default class EntregaDetalhesExpand extends Component {

	state = {
		loading: true,
		error: null,
		entregaFetched: null,
		registros: [],
		tentativaDetalheIdx: null,
		fotoLightbox: null,
	}

	componentDidMount(){
		this.carregar();
	}

	componentDidUpdate(prevProps, prevState){
		if(prevProps.linha.entrega._id !== this.props.linha.entrega._id || prevProps.loja !== this.props.loja){
			this.setState({ tentativaDetalheIdx: null, fotoLightbox: null });
			this.carregar();
		}
		if(this.state.fotoLightbox && !prevState.fotoLightbox){
			this._onKeyLightbox = (ev) => {
				if(ev.key === 'Escape') this.closeFotoLightbox();
				else if(ev.key === 'ArrowLeft') this.lightboxPrev();
				else if(ev.key === 'ArrowRight') this.lightboxNext();
			};
			document.addEventListener('keydown', this._onKeyLightbox);
			document.body.style.overflow = 'hidden';
		}
		if(!this.state.fotoLightbox && prevState.fotoLightbox){
			if(this._onKeyLightbox){
				document.removeEventListener('keydown', this._onKeyLightbox);
				this._onKeyLightbox = null;
			}
			document.body.style.overflow = '';
		}
	}

	componentWillUnmount(){
		if(this._onKeyLightbox){
			document.removeEventListener('keydown', this._onKeyLightbox);
		}
		document.body.style.overflow = '';
	}

	carregar = () => {
		const { linha, loja } = this.props;
		const entregaId = linha.entrega._id;
		if(!entregaId || !loja) return;
		this.setState({ loading: true, error: null });
		axios.get(`${api}/${versao}/api/entregas/admin/${entregaId}?loja=${loja}`, getHeaders())
			.then((res) => {
				this.setState({
					loading: false,
					entregaFetched: res.data.entrega,
					registros: Array.isArray(res.data.registros) ? res.data.registros : [],
				});
			})
			.catch((err) => {
				const msg = err.response && err.response.data && err.response.data.error
					? err.response.data.error
					: 'Não foi possível carregar o detalhamento.';
				this.setState({ loading: false, error: msg });
			});
	}

	toggleTentativaDetalhe = (idx) => {
		this.setState((prev) => ({
			tentativaDetalheIdx: prev.tentativaDetalheIdx === idx ? null : idx,
		}));
	}

	openFotoLightbox = (urls, index) => {
		if(!urls || !urls.length) return;
		this.setState({ fotoLightbox: { urls, index: Math.min(index, urls.length - 1) } });
	}

	closeFotoLightbox = () => {
		this.setState({ fotoLightbox: null });
	}

	lightboxPrev = () => {
		this.setState((s) => {
			if(!s.fotoLightbox || !s.fotoLightbox.urls.length) return null;
			const n = s.fotoLightbox.urls.length;
			const i = (s.fotoLightbox.index - 1 + n) % n;
			return { fotoLightbox: { ...s.fotoLightbox, index: i } };
		});
	}

	lightboxNext = () => {
		this.setState((s) => {
			if(!s.fotoLightbox || !s.fotoLightbox.urls.length) return null;
			const n = s.fotoLightbox.urls.length;
			const i = (s.fotoLightbox.index + 1) % n;
			return { fotoLightbox: { ...s.fotoLightbox, index: i } };
		});
	}

	copiarLinkAbs = (abs) => {
		if(!abs) return;
		if(navigator.clipboard && navigator.clipboard.writeText){
			navigator.clipboard.writeText(abs).then(() => window.alert('Link copiado.')).catch(() => window.prompt('Copie o link:', abs));
		}else{
			window.prompt('Copie o link:', abs);
		}
	}

	render(){
		const { linha } = this.props;
		const { loading, error, entregaFetched, registros, tentativaDetalheIdx, fotoLightbox } = this.state;
		const e = mergeEntregaCliente(linha.entrega, entregaFetched);
		const pedido = e.pedido || {};
		const cliente = pedido.cliente || {};
		const nomeCliente = cliente.nome || '—';
		const telCliente = (cliente.telefones && cliente.telefones[0]) ? cliente.telefones[0] : '—';
		const simplePedido = pedido.simpleId || e.simpleId || e._id;
		const end = e.endereco || {};
		const endText = [end.local, end.numero, end.bairro, end.complemento].filter(Boolean).join(', ');
		const entNome = e.entregador && e.entregador.nome ? e.entregador.nome : '—';
		const loteCod = e.loteAtual && e.loteAtual.codigo ? e.loteAtual.codigo : '—';
		const loteCriado = e.loteAtual && e.loteAtual.createdAt ? fmtData(e.loteAtual.createdAt) : '—';
		const tentativas = Array.isArray(e.tentativas) ? e.tentativas : [];
		const registrosTimeline = [...registros].sort((a, b) => {
			const ta = a.createdAt ? new Date(a.createdAt).getTime() : 0;
			const tb = b.createdAt ? new Date(b.createdAt).getTime() : 0;
			return ta - tb;
		});

		return (
			<>
				<div className="order-section">
					<div className="head-info">
						<h1>Pedido {simplePedido}</h1>
						<div className="entregaDetalhesExpand-headAside">
							<p
								className={`entregaDetalhesExpand-deliveryStatus ${deliveryStatusHeadClass(e)}`}
								title="Situação da entrega"
							>
								<i className="fa fa-shipping-fast" aria-hidden="true"></i> {e.status || '—'}
							</p>
						</div>
					</div>
					{ pedido.createdAt && (
						<label>
							Compra realizada em {moment(pedido.createdAt).format('DD/MM/YYYY')} às {moment(pedido.createdAt).format('HH:mm:ss')}
						</label>
					) }
					<label>
						Deverá ser entregue em <span className="bold">{e.shippingDate || '—'}</span> no período da <span className="bold">{e.shippingPeriod || '—'}</span>
					</label>

					<div className="list-items">
						<div className="info">
							<h3>Cliente</h3>
							<span>
								{nomeCliente}
								{ cliente._id && (
									<Link to={`/cliente/${cliente._id}`} className="viewClient">Ver mais</Link>
								) }
							</span>
						</div>
						<div className="info">
							<h3>Telefone</h3>
							<span>{telCliente}</span>
						</div>

						<div className="line"></div>

						<div className="info">
							<h3>Situação da entrega</h3>
							<span>{e.status || '—'}</span>
						</div>
						<div className="info">
							<h3>Entregador</h3>
							<span>{entNome}</span>
						</div>
						<div className="info">
							<h3>Lote atual</h3>
							<span>Código {loteCod} · Criado em {loteCriado}</span>
						</div>

						<div className="line"></div>

						<div className="info">
							<h3>Quem envia</h3>
							<span>{e.shippingSender || '—'}</span>
						</div>
						<div className="info">
							<h3>Quem recebe</h3>
							<span>{e.shippingRecipient || '—'}</span>
						</div>

						<div className="line"></div>

						<div className="info">
							<h3>Endereço de entrega</h3>
							<span>{endText || '—'}</span>
						</div>
					</div>

					{ loading && (
						<p className="entregaDetalhesExpand-footnote">Carregando histórico de tentativas…</p>
					) }
					{ error && (
						<p className="entregaDetalhesExpand-erroInline">{error}</p>
					) }

					{ !loading && !error && tentativas.length > 0 && (
						<div className="order-section entregaDetalhesExpand-extra">
							<h2 className="entregaDetalhesExpand-h2">Tentativas</h2>
							<ul className="entregaTentativas-lista">
								{ tentativas.map((t, idx) => {
									const en = t.entregador && t.entregador.nome ? t.entregador.nome : '—';
									const lc = t.lote && t.lote.codigo ? t.lote.codigo : '—';
									const res = t.resultado === 'entregue' ? 'Entregue' : t.resultado === 'nao_entregue' ? 'Não entregue' : 'Em andamento';
									const aberto = tentativaDetalheIdx === idx;
									const prova = t.prova || {};
									const mapsUrl = urlMapsProva(prova.geo);
									const confirmAbs = urlConfirmacaoAbs(t.mobileToken);
									const coordsTxt = prova.geo && typeof prova.geo.lat === 'number' && typeof prova.geo.lng === 'number'
										? ` (${prova.geo.lat.toFixed(5)}, ${prova.geo.lng.toFixed(5)})`
										: '';
									const fotosProva = Array.isArray(prova.fotoUrls)
										? prova.fotoUrls.filter(Boolean)
										: [];

									return (
										<li key={t._id ? String(t._id) : `t-${idx}`} className="entregaTentativas-item">
											<span><strong>Lote {lc}</strong> — {en}</span>
											<span>Atribuído: {fmtData(t.atribuidoEm)}</span>
											{ t.saiuParaEntregaEm && <span>Saiu para entrega: {fmtData(t.saiuParaEntregaEm)}</span> }
											<span className="entregaTentativas-resultado">Resultado: {res}</span>
											{ t.motivoNaoEntrega && <span className="entregaTentativas-motivo">Motivo: {t.motivoNaoEntrega}</span> }
											{ prova.registradoEm && (
												<span className="entregaTentativas-prova">Registro: {fmtData(prova.registradoEm)}</span>
											) }
											<button
												type="button"
												className="entregaTentativa-maisBtn"
												onClick={() => this.toggleTentativaDetalhe(idx)}
											>
												{ aberto ? 'Menos detalhes' : 'Mais detalhes' }
											</button>
											{ aberto && (
												<div className="entregaTentativa-detalhe">
													{ fotosProva.length > 0 && (
														<div className="entregaTentativa-detalheFoto">
															<h4>{fotosProva.length > 1 ? 'Fotos da prova' : 'Foto da prova'}</h4>
															<div className="entregaTentativa-detalheFotosGrid">
																{ fotosProva.map((src, fi) => (
																	<button
																		key={fi}
																		type="button"
																		className="entregaTentativa-fotoThumb"
																		onClick={() => this.openFotoLightbox(fotosProva, fi)}
																		aria-label={`Abrir foto ${fi + 1} em tamanho grande`}
																	>
																		<img src={src} alt={`Prova de entrega ${fi + 1}`} />
																	</button>
																)) }
															</div>
														</div>
													) }
													{ mapsUrl && (
														<p className="entregaTentativa-detalheLinha">
															<strong>Localização registrada:</strong>{' '}
															<a href={mapsUrl} target="_blank" rel="noopener noreferrer">Abrir no Google Maps</a>
															<span className="entregaTentativa-coords">{coordsTxt}</span>
														</p>
													) }
													{ (!fotosProva.length && !mapsUrl && !(prova.observacao && String(prova.observacao).trim()) && !confirmAbs) && (
														<p className="entregaTentativa-semProva">Nenhuma foto, localização ou observação registrada nesta tentativa.</p>
													) }
													{ prova.observacao && String(prova.observacao).trim() && (
														<div className="entregaTentativa-detalheObs">
															<h4>Observações do entregador</h4>
															<p>{prova.observacao}</p>
														</div>
													) }
													{ confirmAbs && (
														<div className="entregaTentativa-detalheLink">
															<h4>Link de confirmação (entregador)</h4>
															<p>
																<a href={confirmAbs} target="_blank" rel="noopener noreferrer">Abrir página de confirmação</a>
																{' · '}
																<button type="button" className="entregaTentativa-copiarBtn" onClick={() => this.copiarLinkAbs(confirmAbs)}>
																	Copiar link
																</button>
															</p>
														</div>
													) }
												</div>
											) }
										</li>
									);
								}) }
							</ul>
						</div>
					) }

					{ !loading && !error && registros.length > 0 && (
						<div className="order-section">
							<div className="status-container">
								<h2>Histórico no pedido</h2>
								<ol className="entregaDetalhesExpand-timeline" aria-label="Linha do tempo do pedido">
									{ registrosTimeline.slice(0, 12).map((r) => (
										<li key={r._id} className="entregaDetalhesExpand-timelineItem">
											<span className="entregaDetalhesExpand-timelineAxis" aria-hidden="true">
												<span className="entregaDetalhesExpand-timelineDot" />
											</span>
											<div className="entregaDetalhesExpand-timelineBody">
												<time className="entregaDetalhesExpand-timelineTime" dateTime={r.createdAt ? new Date(r.createdAt).toISOString() : undefined}>
													{fmtData(r.createdAt)}
												</time>
												<p className="entregaDetalhesExpand-timelineTitle">{r.situacao || '—'}</p>
												{ r.responsavel && (
													<p className="entregaDetalhesExpand-timelineMeta">{r.responsavel}</p>
												) }
											</div>
										</li>
									)) }
								</ol>
							</div>
						</div>
					) }
				</div>

				{ fotoLightbox && fotoLightbox.urls && fotoLightbox.urls.length > 0 && (
					<div
						className="entregaFotoLightbox"
						role="dialog"
						aria-modal="true"
						aria-label="Foto em tamanho grande"
						onClick={this.closeFotoLightbox}
					>
						<button
							type="button"
							className="entregaFotoLightbox-close"
							aria-label="Fechar"
							onClick={(ev) => {
								ev.stopPropagation();
								this.closeFotoLightbox();
							}}
						>
							×
						</button>
						{ fotoLightbox.urls.length > 1 && (
							<>
								<button
									type="button"
									className="entregaFotoLightbox-nav entregaFotoLightbox-nav--prev"
									aria-label="Foto anterior"
									onClick={(ev) => {
										ev.stopPropagation();
										this.lightboxPrev();
									}}
								>
									‹
								</button>
								<button
									type="button"
									className="entregaFotoLightbox-nav entregaFotoLightbox-nav--next"
									aria-label="Próxima foto"
									onClick={(ev) => {
										ev.stopPropagation();
										this.lightboxNext();
									}}
								>
									›
								</button>
							</>
						) }
						<div
							className="entregaFotoLightbox-inner"
							onClick={(ev) => ev.stopPropagation()}
						>
							<img
								src={fotoLightbox.urls[fotoLightbox.index]}
								alt={`Prova de entrega ${fotoLightbox.index + 1} de ${fotoLightbox.urls.length}`}
							/>
						</div>
						{ fotoLightbox.urls.length > 1 && (
							<p className="entregaFotoLightbox-counter">
								{fotoLightbox.index + 1} / {fotoLightbox.urls.length}
							</p>
						) }
					</div>
				) }
			</>
		);
	}
}
